<template>
	<div>
		<i v-if="index == 1" :style="style" class="icon iconfont icontree_icon_text"></i>
		<i v-if="index == 2" :style="style" class="icon iconfont iconhome_icon_txt"></i>
		<i v-if="index == 3" :style="style" class="icon iconfont icontree_icon_text"></i>
	</div>
</template>

<script>
export default {
	data() {
		return{
			
		}
	},
	props: {
		color: {
			type: String,
			default: '#034FA3'
		},
		index: {
			type: Number,
			default: 1
		},
		font:{
			type: String,
			default: '12px'
		}
	},
	mounted() {
	},
	computed:{
		style(){
			return 'font-size:'+this.font+';color:'+this.color
		}
	},
	methods: {}
};
</script>

<style></style>
